import { createContext, useContext } from 'react';

// Contexto y tipos del chrome por-página (breadcrumb del topbar + texto de la
// cinta). Separado del .tsx para no romper el fast-refresh (solo-componentes).

export interface Crumb {
  label: string;
  to?: string;
  /** `state` de navegación del enlace (p. ej. el origen de la ficha, ver lib/back-nav). */
  state?: unknown;
  strong?: boolean;
}

export interface PageChromeState {
  breadcrumb: Crumb[];
  ribbonRight: string | null;
  navContext: string | null;
}

export interface PageChromeContextValue extends PageChromeState {
  set: (state: PageChromeState) => void;
}

export const DEFAULT_CHROME: PageChromeState = {
  breadcrumb: [{ label: 'QMS', strong: true }],
  ribbonRight: null,
  navContext: null,
};

export const PageChromeContext = createContext<PageChromeContextValue | null>(null);

export function useChromeContext(): PageChromeContextValue {
  const ctx = useContext(PageChromeContext);
  if (!ctx) {
    throw new Error('PageChrome debe usarse dentro de PageChromeProvider');
  }
  return ctx;
}

/** Lectura del chrome actual (Header/Ribbon). */
export function usePageChrome(): PageChromeState {
  return useChromeContext();
}
